//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

// npm packages
import { useContext } from "react";
import { toast } from "react-toastify";
import { useHistory } from "react-router-dom";

// custom pages
import Context from "context/context";

const HandleApiResponse = () => {
  const { state, dispatch } = useContext(Context);

  const history = useHistory();
  let toastCss = {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: false,
    draggable: true,
    progress: undefined,
  };

  async function handleResponse(res) {
    let body = await res.json();
    if (res && (res.status === 401 || res.status === 400)) {
      let unauthorized = sessionStorage.getItem("unauthorized");
      if (!unauthorized) {
        sessionStorage.setItem("unauthorized", true);
        toast.error(
          body && body.message ? body.message : "something went wrong.",
          toastCss
        );
      }
      sessionStorage.removeItem("ca");
      sessionStorage.removeItem("ui");
      dispatch({ type: "SET_LOADING", payload: false });
      history.push("/login");
      return;
    }
    if (res && (res.status === 200 || res.status === 201 )) {
      return body;
    }
  }

  async function handleError(err) {
    toast.error("something went wrong.", toastCss);
  }

  return {
    handleResponse,
    handleError,
  };
};
export default HandleApiResponse;
